import { createTemplate } from "@videojs/utils/dom";
//#region src/internal/skins/neutral-live-video/template.ts
/** Static template rendered from the finalized VJSC module graph. */
const template = createTemplate(`<media-container class="media-skin media-container video-skin" data-theme="neutral" data-preset="live-video">
<slot>
</slot>
<media-poster class="media-poster">
<slot name="poster">
<img alt="" decoding="async" class="media-poster-image">
</slot>
</media-poster>
<media-buffering-indicator class="media-buffering-indicator">
<media-icon family="neutral" name="spinner" class="media-buffering-indicator-spinner-icon">
</media-icon>
</media-buffering-indicator>
<media-error-dialog class="media-dialog-root">
<media-dialog-backdrop class="media-dialog-backdrop">
</media-dialog-backdrop>
<media-dialog-popup class="media-dialog-popup">
<div class="media-dialog-content">
<media-dialog-title class="media-dialog-title">
</media-dialog-title>
<media-dialog-description class="media-dialog-description">
</media-dialog-description>
</div>
<div class="media-dialog-actions">
<media-dialog-close class="media-button media-dialog-close">
</media-dialog-close>
</div>
</media-dialog-popup>
</media-error-dialog>
<media-title class="media-title">
</media-title>
<media-controls>
<media-controls-backdrop class="video-controls-backdrop">
</media-controls-backdrop>
<media-controls-content class="video-controls video-controls-content">
<media-tooltip-group>
<media-controls-group class="video-controls-start">
<media-play-button class="media-button media-play-button" id="vjs-OeFZ9JA8-0-trigger">
<media-icon family="neutral" name="restart" class="media-button-icon media-play-button-restart-icon">
</media-icon>
<media-icon family="neutral" name="play" class="media-button-icon media-play-button-play-icon">
</media-icon>
<media-icon family="neutral" name="pause" class="media-button-icon media-play-button-pause-icon">
</media-icon>
</media-play-button>
<media-tooltip trigger="vjs-OeFZ9JA8-0-trigger" side="top" class="media-popup media-popup-safe-area media-popup-transition media-popup-surface media-tooltip">
<media-tooltip-label>
</media-tooltip-label>
<media-tooltip-shortcut class="media-tooltip-shortcut">
</media-tooltip-shortcut>
</media-tooltip>
<media-live-button class="media-button media-live-button">
</media-live-button>
<media-mute-button commandfor="vjs-mDtO2tpE-0-popup" class="media-button media-mute-button" id="vjs-OeFZ9JA8-0-2-trigger">
<media-icon family="neutral" name="volume-off" class="media-button-icon media-mute-button-off-icon">
</media-icon>
<media-icon family="neutral" name="volume-low" class="media-button-icon media-mute-button-low-icon">
</media-icon>
<media-icon family="neutral" name="volume-high" class="media-button-icon media-mute-button-high-icon">
</media-icon>
</media-mute-button>
<media-tooltip trigger="vjs-OeFZ9JA8-0-2-trigger" delay="0" sticky side="top" class="media-popup media-popup-safe-area media-popup-transition media-popup-surface media-tooltip">
<media-tooltip-label>
</media-tooltip-label>
<media-tooltip-shortcut class="media-tooltip-shortcut">
</media-tooltip-shortcut>
</media-tooltip>
<media-volume-popover open-on-hover delay="200" close-delay="100" side="right" class="media-popup media-popup-safe-area media-popup-transition media-popup-surface media-volume-popover" id="vjs-mDtO2tpE-0-popup">
<media-volume-slider class="media-slider media-volume-slider" thumb-alignment="edge" orientation="horizontal">
<media-slider-track class="media-slider-track">
<media-slider-fill class="media-slider-fill">
</media-slider-fill>
</media-slider-track>
<media-slider-thumb class="media-slider-thumb media-volume-slider-thumb">
</media-slider-thumb>
</media-volume-slider>
</media-volume-popover>
</media-controls-group>
<div aria-hidden="true" class="video-controls-spacer">
</div>
<media-controls-group class="video-controls-end">
<media-captions-button commandfor="vjs-V8IJ3MFn-0-popup" class="media-button media-captions-button" id="vjs-OeFZ9JA8-0-3-trigger">
<media-icon family="neutral" name="captions-off" class="media-button-icon media-captions-button-off-icon">
</media-icon>
<media-icon family="neutral" name="captions-on" class="media-button-icon media-captions-button-on-icon">
</media-icon>
</media-captions-button>
<media-tooltip trigger="vjs-OeFZ9JA8-0-3-trigger" side="top" class="media-popup media-popup-safe-area media-popup-transition media-popup-surface media-tooltip">
<media-tooltip-label>
</media-tooltip-label>
<media-tooltip-shortcut class="media-tooltip-shortcut">
</media-tooltip-shortcut>
</media-tooltip>
<media-menu side="top" align="center" boundary="viewport" class="media-popup media-popup-surface media-menu-popup" id="vjs-V8IJ3MFn-0-popup">
<media-menu-content class="media-menu-content">
<media-captions-radio-group class="media-menu-radio-group">
<template>
<media-menu-radio-item class="media-menu-radio-item">
<span data-part="label">
</span>
<media-menu-item-indicator force-mount class="media-menu-item-indicator">
<media-icon family="neutral" name="check" class="media-menu-radio-item-icon">
</media-icon>
</media-menu-item-indicator>
</media-menu-radio-item>
</template>
</media-captions-radio-group>
</media-menu-content>
</media-menu>
<media-cast-button class="media-button media-cast-button" id="vjs-OeFZ9JA8-0-4-trigger">
<media-icon family="neutral" name="cast-enter" class="media-button-icon media-cast-button-enter-icon">
</media-icon>
<media-icon family="neutral" name="cast-exit" class="media-button-icon media-cast-button-exit-icon">
</media-icon>
</media-cast-button>
<media-tooltip trigger="vjs-OeFZ9JA8-0-4-trigger" side="top" class="media-popup media-popup-safe-area media-popup-transition media-popup-surface media-tooltip">
<media-tooltip-label>
</media-tooltip-label>
<media-tooltip-shortcut class="media-tooltip-shortcut">
</media-tooltip-shortcut>
</media-tooltip>
<media-airplay-button class="media-button media-airplay-button" id="vjs-OeFZ9JA8-0-5-trigger">
<media-icon family="neutral" name="airplay-enter" class="media-button-icon media-airplay-button-enter-icon">
</media-icon>
<media-icon family="neutral" name="airplay-exit" class="media-button-icon media-airplay-button-exit-icon">
</media-icon>
</media-airplay-button>
<media-tooltip trigger="vjs-OeFZ9JA8-0-5-trigger" side="top" class="media-popup media-popup-safe-area media-popup-transition media-popup-surface media-tooltip">
<media-tooltip-label>
</media-tooltip-label>
<media-tooltip-shortcut class="media-tooltip-shortcut">
</media-tooltip-shortcut>
</media-tooltip>
<media-pip-button class="media-button media-pip-button" id="vjs-OeFZ9JA8-0-6-trigger">
<media-icon family="neutral" name="pip-enter" class="media-button-icon media-pip-button-enter-icon">
</media-icon>
<media-icon family="neutral" name="pip-exit" class="media-button-icon media-pip-button-exit-icon">
</media-icon>
</media-pip-button>
<media-tooltip trigger="vjs-OeFZ9JA8-0-6-trigger" side="top" class="media-popup media-popup-safe-area media-popup-transition media-popup-surface media-tooltip">
<media-tooltip-label>
</media-tooltip-label>
<media-tooltip-shortcut class="media-tooltip-shortcut">
</media-tooltip-shortcut>
</media-tooltip>
<media-fullscreen-button class="media-button media-fullscreen-button" id="vjs-OeFZ9JA8-0-7-trigger">
<media-icon family="neutral" name="fullscreen-enter" class="media-button-icon media-fullscreen-button-enter-icon">
</media-icon>
<media-icon family="neutral" name="fullscreen-exit" class="media-button-icon media-fullscreen-button-exit-icon">
</media-icon>
</media-fullscreen-button>
<media-tooltip trigger="vjs-OeFZ9JA8-0-7-trigger" side="top" class="media-popup media-popup-safe-area media-popup-transition media-popup-surface media-tooltip">
<media-tooltip-label>
</media-tooltip-label>
<media-tooltip-shortcut class="media-tooltip-shortcut">
</media-tooltip-shortcut>
</media-tooltip>
</media-controls-group>
</media-tooltip-group>
</media-controls-content>
</media-controls>
<media-hotkey keys="Space" action="togglePaused">
</media-hotkey>
<media-hotkey keys="k" action="togglePaused">
</media-hotkey>
<media-hotkey keys="m" action="toggleMuted">
</media-hotkey>
<media-hotkey keys="ArrowUp" action="volumeStep">
</media-hotkey>
<media-hotkey keys="ArrowDown" action="volumeStep">
</media-hotkey>
<media-hotkey keys="f" action="toggleFullscreen">
</media-hotkey>
<media-hotkey keys="c" action="toggleSubtitles">
</media-hotkey>
<media-hotkey keys="i" action="togglePictureInPicture">
</media-hotkey>
<media-gesture type="tap" action="togglePaused" pointer="mouse" region="center">
</media-gesture>
<media-gesture type="tap" action="toggleControls" pointer="touch">
</media-gesture>
<media-gesture type="doubletap" action="toggleFullscreen" region="center">
</media-gesture>
<media-status-announcer class="media-status-announcer">
</media-status-announcer>
<div class="video-status-indicators">
<media-volume-indicator class="media-indicator media-volume-indicator">
<media-volume-indicator-fill class="media-indicator-content media-volume-indicator-fill">
<media-icon family="neutral" name="volume-high" class="media-volume-indicator-high-icon">
</media-icon>
<media-icon family="neutral" name="volume-low" class="media-volume-indicator-low-icon">
</media-icon>
<media-icon family="neutral" name="volume-off" class="media-volume-indicator-off-icon">
</media-icon>
<media-volume-indicator-value class="media-volume-indicator-value">
</media-volume-indicator-value>
</media-volume-indicator-fill>
</media-volume-indicator>
<media-status-indicator actions="toggleSubtitles,toggleFullscreen,togglePictureInPicture" class="media-indicator media-status-indicator">
<div class="media-indicator-content media-status-indicator-content">
<media-icon family="neutral" name="captions-on" class="media-status-indicator-captions-on-icon">
</media-icon>
<media-icon family="neutral" name="captions-off" class="media-status-indicator-captions-off-icon">
</media-icon>
<media-icon family="neutral" name="fullscreen-enter" class="media-status-indicator-fullscreen-enter-icon">
</media-icon>
<media-icon family="neutral" name="fullscreen-exit" class="media-status-indicator-fullscreen-exit-icon">
</media-icon>
<media-icon family="neutral" name="pip-enter" class="media-status-indicator-pip-enter-icon">
</media-icon>
<media-icon family="neutral" name="pip-exit" class="media-status-indicator-pip-exit-icon">
</media-icon>
<media-status-indicator-value class="media-status-indicator-value">
</media-status-indicator-value>
</div>
</media-status-indicator>
<media-status-indicator actions="togglePaused" class="media-playback-status-indicator">
<media-icon family="neutral" name="play" class="media-playback-status-indicator-play-icon">
</media-icon>
<media-icon family="neutral" name="pause" class="media-playback-status-indicator-pause-icon">
</media-icon>
</media-status-indicator>
</div>
</media-container>`);
//#endregion
export { template };
